export const MenuListArray2 = [
    {
        title: 'Home',
        classChange: '',
        to: '/',
    },
    {
        title: 'About Us',
        classChange: '',
        to: '/libraries',
    },
    {
        title: 'Libraries',
        classChange: '',
        to: '/libraries',
    },
    {
        title: 'BMI Calculator',
        classChange: '',
        to: '/bmi-calculator',
    },
    {
        title: 'Contact Us',
        classChange: '',
        to: '/#contact',
    },
    {
        title: 'My Schedule',
        classChange: '',
        to: '/my-schedule',
    },
];
